<div class="compare-banner" *ngIf="compareData?.length > 0; ">
  <div class="compare-banner__content">
    <span class="compare-banner__label">Select vehicles to compare.</span>
    <div class="compare-banner__trucks">
      <div class="compare-banner__truck" *ngFor="let truck of compareData; let i = index">
        <img
          [src]="truck.pictures[0]?.filenameSmall ? (truck.pictures[0].filenameSmall | volvoCdn | escapeUrl) : 'assets/icons/Imagescomingsoon.png'"
          [alt]="truck?.title || truck?.specification?.model || 'Truck image'" class="compare-banner__truck-img" />
        <div class="compare-banner__truck-info">
          <div class="compare-banner__truck-title">
            {{ truck?.specification?.make || '' }} {{ truck?.specification?.model || '' }}
            {{ truck?.specification?.horsePower || '' }}
          </div>
          <div class="compare-banner__truck-price">
            {{ truck?.pricing?.priceExclVatEuro || 'Ask for price' }}
          </div>
        </div>
        <button class="compare-banner__truck-remove" (click)="removeFromComparison(truck); $event.stopPropagation();"
          aria-label="Remove truck">
          <img [src]="assetService.getAssetUrl('assets/icons/close.svg')" alt="Remove truck icon" width="20"
            height="20" />
        </button>
      </div>
      <ng-container *ngIf="compareData.length < 3">
        <div *ngFor="let p of [].constructor(3 - compareData.length); let idx = index"
          class="compare-banner__placeholder">
          {{ compareData.length + idx + 1 }}
        </div>
      </ng-container>
    </div>
    <div class="compare-banner__actions">
      <button class="compare-banner__clear" (click)="clearComparison()">
        <img [src]="assetService.getAssetUrl('assets/icons/close.svg')" alt="Clear all" width="20" height="20" />
        Clear all
      </button>
      <button class="compare-banner__action" [disabled]="compareData.length < 2" (click)="compareTrucks()">Compare {{
        compareData.length }}/3</button>
    </div>
    <!-- <div class="compare-banner__breakpoint-debug"></div> -->
  </div>
</div>